import { FieldValueSet } from '@servicetitan/financing-workflow-shared';

/**
 * Coerces a field value to a provider's allowed value-set: any non-allowed value becomes the
 * set's fallback. Null/undefined pass through as `undefined` so callers can apply their own
 * defaulting (e.g. `?? ResidenceOwnership.NotSet`).
 *
 * This replaces per-value, per-provider coercion logic (e.g. the old
 * `sanitizeResidenceTypeForFirstLook`) with a single generic transform driven by the provider's
 * declared FieldValueSet, so the "which values does this provider accept" rule lives in exactly
 * one place.
 */
export const sanitizeFieldValue = (
    value: unknown,
    { allowed, fallback }: FieldValueSet,
): string | undefined => {
    if (value === null || value === undefined) {
        return undefined;
    }
    return (allowed as readonly string[]).includes(value as string) ? (value as string) : fallback;
};
